import { warn } from './logger'

const LEGACY_ERROR_CODE_PROPS = ['result', 'error', 'error_code']
export const DEFAULT_ERROR_CODE_PROP = 'code'
const DEFAULT_ERROR_CODE = 'N/A'

const LEGACY_ERROR_MSG_PROPS = ['error_message', 'message', 'error_msg']
export const DEFAULT_ERROR_MSG_PROP = 'msg'
const DEFAULT_ERROR_MSG = 'Error'

function warnWhenLegacyFound(key, rightKey) {
  warn(`[Http Warning] 'response.body.${key}' was deprecated, please ask the backend to change it to '${rightKey}'`)
}

export function getErrorCodeFromData(data = {}) {
  let errorCode = data[DEFAULT_ERROR_CODE_PROP]

  if (typeof errorCode === 'undefined') {
    LEGACY_ERROR_CODE_PROPS.forEach(key => {
      /* eslint camelcase: 0 */

      if (data[key]) {
        errorCode = data[key]
        warnWhenLegacyFound(key, DEFAULT_ERROR_CODE_PROP)
      }
    })
  }

  if (typeof errorCode === 'undefined') {
    errorCode = DEFAULT_ERROR_CODE
  }

  return errorCode
}

export function getErrorMsgFromData(data = {}) {
  let errorMsg = data[DEFAULT_ERROR_MSG_PROP]

  if (typeof errorMsg === 'undefined') {
    LEGACY_ERROR_MSG_PROPS.forEach(key => {
      /* eslint camelcase: 0 */

      if (data[key]) {
        errorMsg = data[key]
        warnWhenLegacyFound(key, DEFAULT_ERROR_MSG_PROP)
      }
    })
  }

  if (typeof errorMsg === 'undefined') {
    errorMsg = DEFAULT_ERROR_MSG
  }

  return errorMsg
}

export class HTTPClientError extends Error {
  constructor(code, message) {
    super(message)

    this.name = 'HTTPClientError'
    this.code = code
  }
}

export class HTTPServerError extends Error {
  constructor(status, data) {
    super(data.msg)

    this.name = 'HTTPServerError'
    this.code = data.code
    this.status = status
    this.data = data
  }

  get statusCode() {
    warn('[Http Warning] \'statusCode\' was deprecated, please use \'status\'')

    return this.status
  }

  get detail() {
    warn('[Http Warning] \'detail\' was deprecated, please use \'data\'')

    return this.data
  }
}

export class HTTPBizError extends HTTPServerError {
  constructor(...params) {
    super(...params)

    this.name = 'HTTPBizError'
  }
}
